import React from "react";
import { Grid } from "@mui/material";
import { FooterWithDivider, StaticInfoMessage } from "components/common";
import { InlineLabel, Toggle } from "components/common/wintForms";
import SimpleExpansionPanel from "components/common/panels/simpleExpansionPanel";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

type RevisorSigningInfoProps = {
  isAuditCompleted: boolean;
  setIsAuditCompleted: (val: boolean) => void;
  isCustomerApprovedAtLeastOnce: boolean;
};

const AuditorSigningInfo: React.FC<RevisorSigningInfoProps> = (props) => {
  const { isAuditCompleted, setIsAuditCompleted, isCustomerApprovedAtLeastOnce } = props;

  const approveText = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve);
  const approveMarker = "%%APPROVE%%";
  const signingDescriptionText = LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.AnnualAccount.ToApproveTodoHowTheSigningWorksDescription,
    undefined,
    { Approve: approveMarker }
  );
  const [signingDescriptionTitlePart1, signingDescriptionTitlePart2] = signingDescriptionText.split(approveMarker);

  return (
    <>
      {!isCustomerApprovedAtLeastOnce && (
        <Grid item sx={{ mt: 3 }}>
          <StaticInfoMessage displayType={StyleEnums.DisplayType.Warning}>
            {LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.AnnualAccount.CustomerHasNotApprovedWarning
            )}
          </StaticInfoMessage>
        </Grid>
      )}

      <Grid container direction="row" wrap="nowrap" sx={{ mt: 2 }}>
        <InlineLabel
          columns
          descriptionText={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AnnualAccount.AuditCompleteDescription
          )}
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.AuditCompleteLabel)}
        </InlineLabel>
        <Grid item direction="row">
          <Toggle
            name="auditCompleted"
            value={isAuditCompleted}
            setValue={(val: boolean) => setIsAuditCompleted(val)}
            disabled={!isCustomerApprovedAtLeastOnce}
            onChange={() => {}}
            onBlur={() => {}}
            touched
            setTouched={() => {}}
            hasError={false}
          />
        </Grid>
      </Grid>

      <Grid item direction="row" wrap="wrap">
        <FooterWithDivider />
        <SimpleExpansionPanel
          className={`${cssExports.floatSimpleExpansionPanelIconRight} ${cssExports.simpleExpansionPanelTitleBlue}`}
          borderless
          title={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AnnualAccount.ToApproveTodoHowTheSigningWorksTitle
          )}
        >
          <div className={cssExports.auditorSigningDescription}>
            <p>
              {signingDescriptionTitlePart1}
              <strong>{approveText}</strong>
              {signingDescriptionTitlePart2}
            </p>
            <ol>
              <li>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.AnnualAccount.ToApproveTodoBoardSignsAnnualReport
                )}
              </li>
              <li>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.AnnualAccount.ToApproveTodoAuditorSignsAnnualReport
                )}
              </li>
              <li>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.AnnualAccount.ToApproveTodoSigningAuditorConfirmsAuditReportSigned
                )}
              </li>
              <li>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.AnnualAccount.ToApproveTodoBoardSignsAnnualGeneralMeetingProtocol
                )}
              </li>
              <li>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.AnnualAccount.ToApproveTodoBoardSignsSubmissionToBolagsverket
                )}
              </li>
            </ol>
          </div>
        </SimpleExpansionPanel>
      </Grid>
    </>
  );
};

export default AuditorSigningInfo;
